import { PageHeader } from "@/components/common/PageHeader";
import { Loader, EmptyState } from "@/components/common/Loader";
import { usePublicContent } from "@/lib/useContent";
import { ExternalLink } from "lucide-react";

export default function News() {
  const { data, loading } = usePublicContent("posts");
  return (
    <div>
      <PageHeader eyebrow="Stay Updated" titleLeft="TRILOGY " titleRight="NEWS" description="News, tips, and highlights from the Trilogy community." image="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=1600&q=70&auto=format&fit=crop" />
      <section className="bg-background py-16 sm:py-20">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6">
          {loading ? <Loader /> : data.length === 0 ? <EmptyState title="No posts yet" description="Check back soon for news and updates." /> : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {data.map((p) => {
                const date = p.published_at ? new Date(p.published_at) : (p.created_at ? new Date(p.created_at) : null);
                const Wrapper = p.link_url ? "a" : "div";
                const wprops = p.link_url ? { href: p.link_url, target: "_blank", rel: "noopener noreferrer" } : {};
                return (
                  <Wrapper key={p.id} {...wprops} data-testid="news-card" className="group flex flex-col overflow-hidden rounded-xl border border-border bg-card transition-colors hover:border-[hsl(var(--brand-red))]">
                    {p.image_url && (
                      <div className="relative h-44 overflow-hidden">
                        <img src={p.image_url} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                      </div>
                    )}
                    <div className="flex flex-1 flex-col p-5">
                      {p.source && <span className="font-condensed text-xs font-semibold uppercase tracking-wide text-brand">{p.source}</span>}
                      <h3 className="mt-1 display-title text-2xl">{p.title}</h3>
                      {p.excerpt && <p className="mt-2 flex-1 text-sm text-muted-foreground leading-relaxed">{p.excerpt}</p>}
                      <div className="mt-4 flex items-center justify-between text-xs text-muted-foreground">
                        {date && <span>{date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</span>}
                        {p.link_url && <span className="flex items-center gap-1 text-brand">Read more <ExternalLink className="h-3 w-3" /></span>}
                      </div>
                    </div>
                  </Wrapper>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
